import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'text', 'link']);

/**
 * Color mapping for textColor field from Contentful
 * Supports both camelCase and display names (with spaces)
 */
const textColorMap = {
  // Standard keys
  white: 'white',
  black: 'text.primary', // #32312F
  linen: 'primary.linen100', // #C6B5A1
  // Display name variants (from Contentful dropdown)
  White: 'white',
  Black: 'text.primary',
  Linen: 'primary.linen100',
};

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "text" | "link")[]
 * }>} PromoBannerItemStyles
 */

export const promoBannerItemStyles = helpers.defineMultiStyleConfig({
  /**
   * Base styles for PromoBannerItem component
   *
   * @param {Object} args - Component arguments
   * @param {Contentful.PromoBannerItem} args.component - PromoBannerItem component data
   * @param {string} [args.textColor] - Text color from Contentful
   *
   * @returns {PromoBannerItemStyles} - Component styles
   */
  baseStyle({component, textColor}) {
    const color = textColorMap[textColor] || 'white';

    return {
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        color,
      },
      text: {
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '120%',
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },
      link: {
        // Style the wrapper span and its nested link
        'fontSize': '12px',
        'fontStyle': 'normal',
        'fontWeight': 600,
        'lineHeight': '120%',
        // Apply underline to anchor element inside
        '& a, & a span': {
          textDecoration: 'underline',
          textUnderlineOffset: '2px',
        },
        '& a:hover, & a:hover span': {
          textDecoration: 'underline',
          opacity: 0.8,
        },
      },
    };
  },

  variants: {
    default: {},
  },
});
